import { i18n } from '@/locales';
const listLc = 'views.member_company_inquiry.';
/**
 * Enum 정의
 * 게시물구분 항목
 * WORK: '업무문의',
 * VAN: 'VAN관련문의',
 * PRODUCT: '물품요청',
 * CANCEL_DUPLICATED_PAYMENT: '중복결제취소요청',
 * POST_JOB_ADVERTISEMENT: '구인광고게시신청',
 * CONNECT_POS: 'POS연동신청',
 * CHANGE_BUSINESS_NUMBER: '사업자번호변경신청',
 * VAT_REFERENCE: '부가세참고자료',
 * ENTRY_KAKAO_TALK_ORDER: '카카오톡주문하기입점신청',
 * CONNECT_BAEMIN_SERVER: '배달의민족서버연동요청',
 * BIKE_LEASE_AJ_BIKE: '바이크리스신청(AJ바이크)',
 * BIKE_LEASE_BIKE_MASTER: '바이크리스신청(바이크마스터)',
 * BIKE_LEASE_BIKE_BANK: '바이크리스신청(바이크뱅크)',
 * APPLY_ALBAMON: '알바몬신청',
 * CANCEL_ALBAMON: '알바몬해지',
 * APPLY_ALBA_HEAVEN: '알바천국신청',
 * CANCEL_ALBA_HEAVEN: '알바천국해지',
 * 신규등록 시(게시물구분) WORK:업무문의, BIKE_LEASE: '바이크리스신청', JOB_SERVICE: '채용서비스신청',
 */
export const PostCategoryEnum = {
    /** 전체 */
    ALL: '',
    /** 업무문의 */
    WORK: 'WORK',
    /** VAN관련문의 */
    VAN: 'VAN',
    /** 물품요청 */
    PRODUCT: 'PRODUCT',
    /** 중복결제취소요청 */
    CANCEL_DUPLICATED_PAYMENT: 'CANCEL_DUPLICATED_PAYMENT',
    /** 구인광고게시신청 */
    POST_JOB_ADVERTISEMENT: 'POST_JOB_ADVERTISEMENT',
    /** POS연동신청 */
    CONNECT_POS: 'CONNECT_POS',
    /** 사업자번호변경신청 */
    CHANGE_BUSINESS_NUMBER: 'CHANGE_BUSINESS_NUMBER',
    /** 부가세참고자료 */
    VAT_REFERENCE: 'VAT_REFERENCE',
    /** 카카오톡주문하기입점신청 */
    ENTRY_KAKAO_TALK_ORDER: 'ENTRY_KAKAO_TALK_ORDER',
    /** 배달의민족서버연동요청 */
    CONNECT_BAEMIN_SERVER: 'CONNECT_BAEMIN_SERVER',
    /** 바이크리스신청(AJ바이크) */
    BIKE_LEASE_AJ_BIKE: 'BIKE_LEASE_AJ_BIKE',
    /** 바이크리스신청(바이크마스터) */
    BIKE_LEASE_BIKE_MASTER: 'BIKE_LEASE_BIKE_MASTER',
    /** 바이크리스신청(바이크뱅크) */
    BIKE_LEASE_BIKE_BANK: 'BIKE_LEASE_BIKE_BANK',
    /** 알바몬신청 */
    APPLY_ALBAMON: 'APPLY_ALBAMON',
    /** 알바몬해지 */
    CANCEL_ALBAMON: 'CANCEL_ALBAMON',
    /** 알바천국신청 */
    APPLY_ALBA_HEAVEN: 'APPLY_ALBA_HEAVEN',
    /** 알바천국해지 */
    CANCEL_ALBA_HEAVEN: 'CANCEL_ALBA_HEAVEN',
    /** 바이크리스신청 */
    BIKE_LEASE: 'BIKE_LEASE',
    /** 채용서비스신청 */
    JOB_SERVICE: 'JOB_SERVICE',
};
/**
 * Enum 정의
 * 키워드 검색 항목
 */
export const KeywordTypeEnum = {
    TITLE: 'TITLE',
    BODY: 'BODY',
};
/** Options 구성 */
export const findTypeOptions = [
    {
        text: i18n.t('common.all'),
        value: PostCategoryEnum.ALL,
    },
    {
        text: i18n.t(`${listLc}post_category.work`),
        value: PostCategoryEnum.WORK,
    },
    {
        text: i18n.t(`${listLc}post_category.van`),
        value: PostCategoryEnum.VAN,
    },
    {
        text: i18n.t(`${listLc}post_category.product`),
        value: PostCategoryEnum.PRODUCT,
    },
    {
        text: i18n.t(`${listLc}post_category.cancel_duplicated_payment`),
        value: PostCategoryEnum.CANCEL_DUPLICATED_PAYMENT,
    },
    {
        text: i18n.t(`${listLc}post_category.posy_job_advertisement`),
        value: PostCategoryEnum.POST_JOB_ADVERTISEMENT,
    },
    {
        text: i18n.t(`${listLc}post_category.connect_pos`),
        value: PostCategoryEnum.CONNECT_POS,
    },
    {
        text: i18n.t(`${listLc}post_category.chabge_business_number`),
        value: PostCategoryEnum.CHANGE_BUSINESS_NUMBER,
    },
    {
        text: i18n.t(`${listLc}post_category.vat_reference`),
        value: PostCategoryEnum.VAT_REFERENCE,
    },
    {
        text: i18n.t(`${listLc}post_category.entry_kakao_talk_order`),
        value: PostCategoryEnum.ENTRY_KAKAO_TALK_ORDER,
    },
    {
        text: i18n.t(`${listLc}post_category.connrct_baemin_server`),
        value: PostCategoryEnum.CONNECT_BAEMIN_SERVER,
    },
    {
        text: i18n.t(`${listLc}post_category.bike_lease_aj_bike`),
        value: PostCategoryEnum.BIKE_LEASE_AJ_BIKE,
    },
    {
        text: i18n.t(`${listLc}post_category.bike_lease_bike_master`),
        value: PostCategoryEnum.BIKE_LEASE_BIKE_MASTER,
    },
    {
        text: i18n.t(`${listLc}post_category.bike_lease_bike_bank`),
        value: PostCategoryEnum.BIKE_LEASE_BIKE_BANK,
    },
    {
        text: i18n.t(`${listLc}post_category.apply_albamon`),
        value: PostCategoryEnum.APPLY_ALBAMON,
    },
    {
        text: i18n.t(`${listLc}post_category.cancel_albmon`),
        value: PostCategoryEnum.CANCEL_ALBAMON,
    },
    {
        text: i18n.t(`${listLc}post_category.apply_alba_heaven`),
        value: PostCategoryEnum.APPLY_ALBA_HEAVEN,
    },
    {
        text: i18n.t(`${listLc}post_category.cancel_alba_heaven`),
        value: PostCategoryEnum.CANCEL_ALBA_HEAVEN,
    },
];
export const keywordTypeOptions = [
    {
        text: i18n.t('common.text_title'),
        value: KeywordTypeEnum.TITLE,
    },
    {
        text: i18n.t('common.text_body'),
        value: KeywordTypeEnum.BODY,
    },
];
export const postFindTypeCategoryItem = [
    {
        label: i18n.t(`${listLc}post_category.work`),
        key: PostCategoryEnum.WORK,
        value: PostCategoryEnum.WORK,
    },
    {
        label: i18n.t(`${listLc}post_category.bike_lease`),
        key: PostCategoryEnum.BIKE_LEASE,
        value: PostCategoryEnum.BIKE_LEASE,
    },
    {
        label: i18n.t(`${listLc}post_category.job_service`),
        key: PostCategoryEnum.JOB_SERVICE,
        value: PostCategoryEnum.JOB_SERVICE,
    },
];
/**
 * 라디오 옵션 구성
 */
export const radioOptions = {
    WORK: [
        {
            key: PostCategoryEnum.WORK,
            value: PostCategoryEnum.WORK,
            label: i18n.t(`${listLc}post_category.work`),
        },
        {
            key: PostCategoryEnum.PRODUCT,
            value: PostCategoryEnum.PRODUCT,
            label: i18n.t(`${listLc}post_category.product`),
        },
        {
            key: PostCategoryEnum.CANCEL_DUPLICATED_PAYMENT,
            value: PostCategoryEnum.CANCEL_DUPLICATED_PAYMENT,
            label: i18n.t(`${listLc}post_category.cancel_duplicated_payment`),
        },
        {
            key: PostCategoryEnum.CONNECT_POS,
            value: PostCategoryEnum.CONNECT_POS,
            label: i18n.t(`${listLc}post_category.connect_pos`),
        },
        {
            key: PostCategoryEnum.VAT_REFERENCE,
            value: PostCategoryEnum.VAT_REFERENCE,
            label: i18n.t(`${listLc}post_category.vat_reference`),
        },
        {
            key: PostCategoryEnum.ENTRY_KAKAO_TALK_ORDER,
            value: PostCategoryEnum.ENTRY_KAKAO_TALK_ORDER,
            label: i18n.t(`${listLc}post_category.entry_kakao_talk_order`),
        },
        {
            key: PostCategoryEnum.CONNECT_BAEMIN_SERVER,
            value: PostCategoryEnum.CONNECT_BAEMIN_SERVER,
            label: i18n.t(`${listLc}post_category.connrct_baemin_server`),
        },
    ],
    BIKE_LEASE: [
        {
            key: PostCategoryEnum.BIKE_LEASE_AJ_BIKE,
            value: PostCategoryEnum.BIKE_LEASE_AJ_BIKE,
            label: i18n.t(`${listLc}post_category.bike_lease_aj_bike`),
        },
        {
            key: PostCategoryEnum.BIKE_LEASE_BIKE_MASTER,
            value: PostCategoryEnum.BIKE_LEASE_BIKE_MASTER,
            label: i18n.t(`${listLc}post_category.bike_lease_bike_master`),
        },
        {
            key: PostCategoryEnum.BIKE_LEASE_BIKE_BANK,
            value: PostCategoryEnum.BIKE_LEASE_BIKE_BANK,
            label: i18n.t(`${listLc}post_category.bike_lease_bike_bank`),
        },
    ],
    JOB_SERVICE: [
        {
            key: PostCategoryEnum.APPLY_ALBAMON,
            value: PostCategoryEnum.APPLY_ALBAMON,
            label: i18n.t(`${listLc}post_category.apply_albamon`),
        },
        {
            key: PostCategoryEnum.CANCEL_ALBAMON,
            value: PostCategoryEnum.CANCEL_ALBAMON,
            label: i18n.t(`${listLc}post_category.cancel_albmon`),
        },
        {
            key: PostCategoryEnum.APPLY_ALBA_HEAVEN,
            value: PostCategoryEnum.APPLY_ALBA_HEAVEN,
            label: i18n.t(`${listLc}post_category.apply_alba_heaven`),
        },
        {
            key: PostCategoryEnum.CANCEL_ALBA_HEAVEN,
            value: PostCategoryEnum.CANCEL_ALBA_HEAVEN,
            label: i18n.t(`${listLc}post_category.cancel_alba_heaven`),
        },
    ],
};
